import React, { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../_redux/student-level-section/StudentAssignmentAction";
import { redirectToPages, resultAlert } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../../_metronic/_partials/controls";
import { StudentsFilter } from "./students-filter/StudentsFilter";
import { StudentsTable } from "./students-table/StudentsTable";
import { useStudentsUIContext } from "./StudentsUIContext";

export function StudentsCard({
  history,
  grade,
  sectionId
}) {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      ids: studentsUIContext.ids,
      setIds: studentsUIContext.setIds,
      queryParams: studentsUIContext.queryParams
    };
  }, [studentsUIContext]);

  // Getting curret state of Students from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.studentLevelSection }),
    shallowEqual
  );  
  const { actionsLoading, isSuccess, type } = currentState;

  // Students Redux state
  const dispatch = useDispatch();

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  /** Belli Bir Öğrenci Listesini Belli Bir Kur Sınıfına Kaydeder */
  const saveStudents = (ids) => {
    dispatch(actions.saveStudents(sectionId, ids)).then(result => onResult(result));
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push("/ogrenci-kur-siniflari"), 2500);
  };

  const title = <>Öğrenci Listesi{studentsUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{studentsUIProps.ids.length}</span>]</> :
                  ""}
                </>;

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>        
        <CardHeaderToolbar>
          <button
            type="button"
            className="btn btn-primary ml-2"
            onClick={() => saveStudents(studentsUIProps.ids)}
          >
            Kaydet
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <StudentsFilter
          grade={grade}
        />
        <StudentsTable
          grade={grade}
        />
      </CardBody>
    </Card>
  );
}